import { useState } from "react";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

export default function RequestDemo() {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        contact: "",
        numberWithoutCode: "",
        message: "",
    });
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const validate = (data) => {
        const newErrors = {};

        if (!data.name.trim()) newErrors.name = "Full name is required.";

        if(!data.email.trim()){
            newErrors.email = "Email address is required.";
        }
        else if (
            !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.email)
        ) {
            newErrors.email = "Please enter a valid email address.";
        }
        
        if (!data.numberWithoutCode.trim()) {
            newErrors.contact = "Contact number is required.";
        }

        console.log("current number:", data.numberWithoutCode);
        
        setErrorMsg(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleChange = (e) => {
        setFormData({
        ...formData,
        [e.target.name]: e.target.value,
        });
    };
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        validate(formData);
        try{
            const res = await axios.post(
                `${import.meta.env.VITE_BACKEND_API_URL}/post-product-enquery`,
                formData
            );
            setFormData({
                name: "",   
                email: "",
                contact: "",
                numberWithoutCode: "",
                message: "",
            });
            if(res.data.success){
                setSuccessMsg('Your demo request submitted successfully.');
                 setTimeout(() => {
                    const modal = document.getElementById("reqDemo");
                    const modalInstance = window.bootstrap.Modal.getInstance(modal);
                    modalInstance.hide();
                    setSuccessMsg('');
                }, 3000);
            }
        }
        catch(err){
            return;
        }
    }
    
    return (
        <div
            className="modal fade req-demo-modal"
            id="reqDemo"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content">
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                    <div className="modal-body">
                        <div className="video-wrapper">
                            <video src="images/bg-video.mp4" muted autoPlay loop></video>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 img-part">
                                <div className="s-header has-desc">
                                        <div className="col-left">
                                            <div className="tag-dot style-white">
                                                <p className="text text-white fw-semibold">
                                                    See It in Instant Action
                                                </p>
                                            </div>
                                            <h4 className="s_title font-inter_tight fw-semibold text-white letter-space--1">
                                                Let’s Build The
                                                Next <br className="d-none d-lg-block"/>Big Thing!
                                            </h4>
                                            <p className="s_desc letter-space-2 cl-white-70">
                                                Experience dedicated performance, advanced features, and<br className="d-none d-lg-block"/> smooth control, everything in one powerful flight.
                                            </p>
                                        </div>
                                    </div>
                            </div>
                            <div className="col-lg-6 form-part px-sm-3 px-0">
                                <div className="contact-content">
                                    <form className="form-contact" onSubmit={handleSubmit}>
                                        <div className="form-content">
                                            <div className="tf-grid-layout">
                                                {successMsg && <div className="success-msg mt-1">{successMsg}</div>}
                                                <fieldset className="fieldset-ip d-grid">
                                                    <label className="fieldset_label">Name <span className="cl-1">*</span></label>
                                                    <input className="style-2" type="text" name="name" value={formData.name} onChange={handleChange}/>
                                                    {errorMsg.name && <div className="error-msg mt-1">{errorMsg.name}</div>}
                                                </fieldset>
                                                <fieldset className="fieldset-ip d-grid">
                                                    <label className="fieldset_label">Email <span className="cl-1">*</span></label>
                                                    <input className="style-2" type="text" name="email" value={formData.email} onChange={handleChange}/>
                                                    {errorMsg.email && <div className="error-msg mt-1">{errorMsg.email}</div>}
                                                </fieldset>
                                                <fieldset className="fieldset-ip d-grid">
                                                    <label className="fieldset_label">Phone <span className="cl-1">*</span></label>
                                                    <PhoneInput
                                                        defaultCountry="in"
                                                        value={formData.contact}        
                                                        onChange={(phone, meta) => {
                                                            const dialCode = meta?.country?.dialCode
                                                                ? `+${meta.country.dialCode}`
                                                                : "+91";

                                                            let numberWithoutCode = phone.replace(dialCode, "");
                                                            const formattedContact = `${dialCode} ${numberWithoutCode}`;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                contact: formattedContact,
                                                                numberWithoutCode: numberWithoutCode
                                                            }));
                                                        }}
                                                        inputClassName="style-2 phone-inp"
                                                    />
                                                    {errorMsg.contact && <div className="error-msg mt-1">{errorMsg.contact}</div>}
                                                </fieldset>
                                                <fieldset className="fieldset-ip d-grid">
                                                    <label className="fieldset_label">Message</label>
                                                    <textarea className="style-2" name="message" value={formData.message} onChange={handleChange} placeholder="Leave your message"></textarea>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div className="form-action text-center">
                                            <button type="submit" className=" tf-btn btn-2 animate-btn btn-xl-large-2 w-100 d-flex justify-content-center">
                                                <span className="text-body-2">
                                                    Request Demo
                                                </span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}